import { UserPlus, MessageCircle, MoreVertical, Search } from 'lucide-react';
import { Card, CardContent } from '../../components/common/Card';
import { Avatar } from '../../components/common/Avatar';
import { Button } from '../../components/common/Button';
import { Badge } from '../../components/common/Badge';
import { Input } from '../../components/common/Input';

const mockConnections = [
  { id: '1', name: 'Alex Rivera', role: 'Developer', reputation: 1200, avatar: 'https://picsum.photos/seed/alex/100', status: 'online' },
  { id: '2', name: 'Elena Vance', role: 'Designer', reputation: 850, avatar: 'https://picsum.photos/seed/elena/100', status: 'offline' },
  { id: '3', name: 'Jordan Smith', role: 'Researcher', reputation: 2100, avatar: 'https://picsum.photos/seed/jordan/100', status: 'online' },
  { id: '4', name: 'Taylor Wong', role: 'Community Lead', reputation: 1500, avatar: 'https://picsum.photos/seed/taylor/100', status: 'away' },
  { id: '5', name: 'Casey Jones', role: 'Security Analyst', reputation: 920, avatar: 'https://picsum.photos/seed/casey/100', status: 'online' },
  { id: '6', name: 'Morgan Lee', role: 'Product Manager', reputation: 1100, avatar: 'https://picsum.photos/seed/morgan/100', status: 'offline' },
];

export const Connections = () => {
  return (
    <div className="space-y-8">
      <header className="flex flex-col space-y-4 md:flex-row md:items-center md:justify-between md:space-y-0">
        <div>
          <h1 className="text-3xl font-bold text-slate-900">Connections</h1>
          <p className="text-slate-500">Manage your network and circles within the ecosystem.</p>
        </div>
        <div className="flex space-x-2">
          <Button variant="outline">Manage Circles</Button>
          <Button>
            <UserPlus className="mr-2 h-4 w-4" />
            Find People
          </Button>
        </div>
      </header>

      <div className="flex flex-col space-y-4 md:flex-row md:items-center md:space-x-4 md:space-y-0">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <Input placeholder="Search connections..." className="pl-10" />
        </div>
        <div className="flex space-x-2">
          <Badge variant="primary" className="cursor-pointer px-4 py-1">All</Badge>
          <Badge variant="secondary" className="cursor-pointer px-4 py-1">Developers</Badge>
          <Badge variant="secondary" className="cursor-pointer px-4 py-1">Designers</Badge>
        </div>
      </div>

      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {mockConnections.map((person) => (
          <Card key={person.id} hover>
            <CardContent className="pt-6">
              <div className="flex items-start justify-between">
                <div className="relative">
                  <Avatar src={person.avatar} fallback={person.name} size="xl" />
                  <div className={`absolute bottom-0 right-0 h-4 w-4 rounded-full border-2 border-white ${
                    person.status === 'online' ? 'bg-emerald-500' : 
                    person.status === 'away' ? 'bg-amber-500' : 'bg-slate-300'
                  }`} />
                </div>
                <button className="text-slate-400 hover:text-slate-600">
                  <MoreVertical size={20} />
                </button>
              </div>
              
              <div className="mt-4">
                <h3 className="text-lg font-bold text-slate-900">{person.name}</h3>
                <p className="text-sm text-slate-500">{person.role}</p>
                <div className="mt-2 flex items-center space-x-2">
                  <Badge variant="outline">Rep: {person.reputation}</Badge>
                </div>
              </div>

              <div className="mt-6 flex space-x-2">
                <Button variant="primary" size="sm" className="flex-1">
                  <MessageCircle className="mr-2 h-4 w-4" />
                  Message
                </Button>
                <Button variant="outline" size="sm" className="flex-1">Profile</Button>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
